<template>
	<div class="data101">
		<div class="data101Til">
			{{list.data.menuTitle}}
		</div>
		<el-table :data="list.data.content" class="tableEl" :border="false" :show-header="false" :stripe="true">
			<el-table-column prop="file_name"  min-width="150">
				<template slot-scope="scope">
					<div class="fileName">
						{{scope.row.file_name}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="file_size" width="150">
				<template slot-scope="scope">
					<div class="fileSize">
						{{scope.row.file_size}}MB
					</div>
				</template>
			</el-table-column>
			<el-table-column width="150">
				<template slot-scope="scope">
					<div @click="goDownLoad(scope.row)" class="downLoad">
						<div class="downLoadWz">
							Download
						</div>
						<div class="downLoadImage">
							<img src="@/assets/xz.png" />
						</div>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<pwdModel ref="pwdModel" @pwdDownLoad="pwdDownLoad"></pwdModel>
	</div>
</template>

<script>
	import {
		check_cy_popup_api
	} from "@/api/config.js"
	import pwdModel from "@/components/pwdModel.vue"
	export default {
		components: {
			pwdModel
		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				qhShow: true,
				activeIndex: 0,
				isPwd: false,
				item:{},
				// list:[
				// 	{
				// 		img:require('@/assets/product/page10/lc1.png')
				// 	},
				// 	{
				// 		img:require('@/assets/product/page10/lc2.png')
				// 	},
				// 	{
				// 		img:require('@/assets/product/page10/lc3.png')
				// 	},
				// ]
			}
		},
		mounted() {},
		methods: {
			pwdDownLoad(){
				window.open(this.item.file_url, '_blank');
			},
			getUrlValue(e) {
				const url = new URL(window.location.href);
				const params = new URLSearchParams(url.search);
				console.log(params.get(e))
				return params.get(e)
			},
			goVerifyPwd() {
				let t = this;
				let id = this.getUrlValue('id');
				let data = {
					product_id:id,
					file_id:this.item.id
				};
				// this.$startLoading();
				check_cy_popup_api(data).then(res => {
					console.log(res)
					if(res.data.is_need_pwd==1){
						this.$refs.pwdModel.goInit(this.list.color_page_text,this.item.id);
					}else{
						window.open(res.data.file_url, '_blank');
					}
					// this.$endLoading();
				}).catch(err => {
					// this.$endLoading();
					console.log(err)
				})
			},
			goDownLoad(item) {
				this.item=item;
				let id = this.getUrlValue('id');
				if (item.is_need_pwd == 1) {
					this.goVerifyPwd();
				}else{
					if(item.file_url){
						window.open(item.file_url, '_blank');
					}else{
						const screenHeight = window.innerHeight;
						
						// 计算可视区域高度的 20%
						const twentyPercentHeight = screenHeight * 0.22;
						this.$message({
							type:'error',
							message:'No download link available at the moment',
							offset:twentyPercentHeight
						});
					}
				}

			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data101 {
		padding-bottom: 150px;
		width: 1200px;
		margin: 0 auto;

		.data101Til {
			// padding-left: 250px;
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 40px;
		}
	}

	.yjzydw {
		font-size: 20px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #B6B6B6;
		margin-top: 21px;
		text-align: right;
	}

	.tableEl {
		width: 100%;
	}

	@media screen and (max-width:1200px) {
		::v-deep {
			.el-table {
				tr {
					background-color: transparent !important;
				}
			}
		}

		.tableEl {
			width: 100vw !important;
		}

		.yjzydw {
			font-size: 12px !important;
		}

		.data101 {
			width: 100% !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;

			.data101Til {
				padding-left: 0px !important;
				font-size: 24px !important;
				margin-bottom: 20px !important;
				width: 100% !important;
			}
		}
	}

	.fileSize {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 18px;
		color: #010101;
	}

	.fileName {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 18px;
		color: #010101;
	}

	.downLoad {
		font-family: Source Han Sans CN;
		font-weight: 400;
		font-size: 18px;
		color: #31A1F3;
		display: flex;
		align-items: center;
		cursor: pointer;

		.downLoadWz {
			font-family: Source Han Sans CN;
			font-weight: 400;
			font-size: 18px;
			color: #31A1F3;
			margin-right: 14px;
		}

		.downLoadImage {
			display: flex;
			align-items: center;

			img {
				width: 17px;
				height: 17px;
			}
		}
	}
</style>